import React, { ReactNode } from 'react';
import MarketsBreadcrumbs from '../MarketsBreadcrumbs';
import { useSetupAreaVersionContextRequired } from '../SetupAreaVersionContext';
import DetailFieldsList from './DetailFieldsList';
import { CreateDetailFieldButtonPortal } from './CreateDetailFieldForm';
import InnerBlock from '../../../../shared/web/layout/InnerBlock';
import { SimpleBlock } from 'ui-builder';


function PageBlock(props: {
  children: ReactNode,
}) {

  const { setupArea } = useSetupAreaVersionContextRequired();

  return (
    <InnerBlock
      title={`${setupArea.name}: Detail Boxes`}
      headerRight={(
        <CreateDetailFieldButtonPortal />
      )}
    >
      {props.children}
    </InnerBlock>
  );
}

export function DetailFieldsListPage() {

  return (
    <>
      <MarketsBreadcrumbs text="Detail Boxes" />
      <PageBlock>
        <SimpleBlock>
          <DetailFieldsList />
        </SimpleBlock>
      </PageBlock>
    </>
  );
}
